import { forwardRef } from "react";

import { cn } from "../index";

export interface RadioProps extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  multiple?: boolean;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(({ multiple = false, className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      {...props}
      type="radio"
      readOnly
      className={cn(
        `box-border grid min-h-[12px] min-w-[12px] shrink-0 cursor-pointer appearance-none place-content-center rounded-full border-[1px] border-primary-darker-gray`,
        "transition-[border-color_120ms_ease-in-out,transform_120ms_ease-in-out]",
        `before:ease-in-out before:m-[3px] before:block before:h-[6px] before:w-[6px] before:scale-0 before:rounded-full before:shadow-[inset_12px_12px_0_0_var(--color-primary-blue)] before:transition-transform before:duration-[120ms] before:content-['']`,
        "checked:border-primary-blue checked:before:scale-100",
        `disabled:pointer-events-none disabled:cursor-default disabled:before:h-[2px] disabled:before:w-[6px] disabled:before:scale-100 disabled:before:shadow-[inset_0_0_0_6px_var(--color-primary-darker-gray)]`,
        `disabled:checked:border-primary-darker-gray disabled:checked:before:m-[3px] disabled:checked:before:h-[6px] disabled:checked:before:w-[6px] disabled:checked:before:rounded-full disabled:checked:before:shadow-[inset_0_0_0_6px_var(--color-primary-darker-gray)]`,
        multiple && "rounded-[2px] before:rounded-[2px] disabled:checked:before:rounded-none",
        className,
      )}
    />
  );
});
